export const MACROS_COLORS = {
  calories: "#978365",
  protein: "#0A4481",
  carbs: "#e5484d",
  fat: "#FFE629",
};
